/** The year-on-year bridge (G1-N2): one sentence under the headline, and the table behind it among the lines behind the bars. */
import type { ContentCatalog } from "@bsim/contracts";
import { fiscalYearLabel } from "../format";
import { GxTable, type GxColumn, type GxRow } from "../theme/GxTable";
import { figure } from "../theme/figures";
import { BRIDGE_FOOTNOTE, yearBridgeSentence, type YearBridge } from "./yearBridge";

export function YearBridgeSentence({ bridge }: { readonly bridge: YearBridge }) {
  return <p className="gx-results-decomp-line gx-num" data-testid="results.decomp.yearbridge">{yearBridgeSentence(bridge)}</p>;
}

const COLUMNS: readonly GxColumn[] = [{ key: "line", label: "Line" }, { key: "amount", label: "Amount", kind: "number", unit: "usdPerShare" }];

export function YearBridgeTable({ bridge, catalog, priorRoundNo }: { readonly bridge: YearBridge; readonly catalog: ContentCatalog; readonly priorRoundNo: number }) {
  const money = (v: number, signed: boolean): string => figure(v, "usdPerShare", { signed });
  const rows: readonly GxRow[] = [
    { key: "prior", cells: { line: `Your score to date at the end of ${fiscalYearLabel(catalog, priorRoundNo)}`, amount: money(bridge.prior, true) } },
    ...bridge.rows.map((r): GxRow => ({ key: r.key, cells: { line: r.label, amount: money(r.delta, true) } })),
    { key: "now", kind: "total", cells: { line: "Your score to date now", amount: money(bridge.now, true) } },
  ];
  return (
    <div data-testid="results.decomp.yearbridge.table">
      <GxTable testId="results.decomp.yearbridge.rows" dense caption="Last year's score to date, this year's change by cause, and your score to date now" columns={COLUMNS} rows={rows} />
      <p className="gx-small gx-faint" data-testid="results.decomp.yearbridge.note">{BRIDGE_FOOTNOTE}</p>
    </div>
  );
}
